// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"79":"4626d17a","793":"83dcb6d3","886":"7aa86308"}[chunkId] + ".js";
};